import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  // defaultOptions: {
  //   queries: {
  //     staleTime: 5 * 1000,
  //   },
  // },
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
})

export default queryClient
